/* This FaqTemplate requires Tailwind CSS v2.0+ */
import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/outline';
import useLocale from 'next-translate/useTranslation';

import clsxm from '@/lib/clsxm';

import MarkdownBlock from './Chat/MarkdownBlock';

const faqs = [
  {
    question: 'Can I sign up using my own referral link?',
    answer:
      'We kindly remind you that our referral program does not permit self-referrals. The primary intention of our initiative is to inspire our valued affiliates and ambassadors to share information about our products.',
  },
  {
    question: 'Do I need to be an Easy-Peasy.AI customer?',
    answer:
      'While it is often observed that the most successful affiliates are those who are customers of Easy-Peasy.AI and have developed a level of expertise and authority, please note that becoming a customer is not a mandatory prerequisite to join our affiliate program. We warmly welcome all who are interested.',
  },
  {
    question: "What's the referral cookie life?",
    answer:
      'The referral cookie life is 60 days. If someone clicks on an affiliate link and buys within 60 days of the most recent click, the affiliate will receive credit for referring the customer. If they buy after 60 days, the affiliate is not considered to have influenced the purchase, the cookie will expire, and the affiliate will not receive commissions.',
  },
  {
    question: 'When are commissions paid?',
    answer: 'In the first week of every month to your PayPal account.',
  },
  {
    question: 'Can I run paid ads for my affiliate campaigns?',
    answer:
      'You can run your campaigns but as stipulated in our Affiliate Agreement, promoting our products or services by bidding on brand keywords or using them in a way that might mislead our customers is strictly prohibited. These rules are designed to both protect our brands integrity and prevent confusion, and it is crucial that all our affiliates adhere to them in order to ensure a fair and cooperative relationship.',
  },
];

export default function FaqTranscription() {
  const { t } = useLocale('affiliates');

  return (
    <div className='bg-gray-50 dark:bg-slate-900'>
      <div className='mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8'>
        <div className='mx-auto max-w-3xl divide-y-2 divide-gray-200 dark:divide-slate-600'>
          <h2 className='text-center text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Frequently asked questions')}
          </h2>
          <dl className='mt-6 space-y-6 divide-y divide-gray-200 dark:divide-slate-600'>
            {faqs.map((faq) => (
              <Disclosure as='div' key={faq.question} className='pt-6'>
                {({ open }) => (
                  <>
                    <dt className='text-lg'>
                      <Disclosure.Button className='flex w-full items-start justify-between text-left text-gray-400 dark:text-slate-400'>
                        <span className='font-medium text-gray-900 dark:text-slate-200'>
                          {t(faq.question)}
                        </span>
                        <span className='ml-6 flex h-7 items-center'>
                          <ChevronDownIcon
                            className={clsxm(
                              open ? '-rotate-180' : 'rotate-0',
                              'h-6 w-6 transform'
                            )}
                            aria-hidden='true'
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as='dd' className='mt-2 pr-12'>
                      <div className='text-base text-gray-500 dark:text-slate-400'>
                        <MarkdownBlock
                          message={t(faq.answer).replace(/\n/g, '  \n')}
                        />
                      </div>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
